import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import useEditorStore from '../../state-hook';
import MicroProfile from './micro-profile';

const Style = createGlobalStyle`
  #success-icon {
    --success-icon-circle-color: ${props => props.theme.secondaryColor};
    --success-icon-tick-color: #d7dfe7;
  }

  .modal-body.modal-body.modal-body.modal-body.modal-body {
    flex-grow: 2;
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 35px;
    display: flex;
    flex-direction: column;
    align-items: center;

    > strong {
      margin-top: 20px;
      font-size: 24px !important;
      line-height: 29px;
    }

    > #desc {
      max-width: 404px;
      font-size: 19px;
      line-height: 23px;
      margin: 0 1em;
    }
  }

  .modal-footer {
    flex-basis: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    &:after {
      order: 0;
      content: "";
      width: 26px;
      display: block;
    }

    > button.btn-inverted {
      order: -1;
      border-radius: 4px;
      border: 1px solid ${props => props.theme.secondaryColor};
    }

    > button.btn-primary {
      order: 1;
      width: 152px;
    }
  }
`;

const ImpersonaPromptModal = React.forwardRef((props, ref) => {
  const wire = useEditorStore(state => state.wire);
  const currentProfile = useEditorStore(state => state.currentProfile);
  const [intention, setIntention] = React.useState('');
  const [show, setShow] = React.useState(false);

  const present = d => {
    const profile = _.get(wire, 'profile', {});
    if (_.get(currentProfile, 'slug') === profile.slug) {
      props.onDismiss(d);
    } else {
      setIntention(d);
      setShow(true);
    }
  };

  const goBack = () => {
    setShow(false);
    props.onDismiss('invalid');
  };

  const proceed = () => {
    setShow(false);
    props.onDismiss(intention);
  };

  React.useImperativeHandle(ref, () => ({ present }));

  return (
    <Modal
      centered="true"
      dialogAs="article"
      dialogClassName="horizontal"
      show={show}
      onHide={proceed}
      backdrop="static"
    >
      <Style />
      <Modal.Body as="section" className="main">
        <span>
          <svg className="icon" id="success-icon"><use href="#success" /></svg>
        </span>
        <strong className="title">this wire will appear to be published by...</strong>
        <MicroProfile {..._.get(wire, 'profile', {})} />
        <p id="desc">
          If this contributor is correct click publish wire below,
          or you can change the contributor.
        </p>
      </Modal.Body>
      <Modal.Footer as="section" className="bottom">
        <button type="button" className="btn btn-inverted" onClick={goBack}>
          change contributor
        </button>
        <button type="button" className="btn btn-primary" onClick={proceed}>
          {`${intention} wire`}
        </button>
      </Modal.Footer>
    </Modal>
  );
});

ImpersonaPromptModal.propTypes = { onDismiss: PropTypes.func.isRequired };

ImpersonaPromptModal.displayName = 'ImpersonaPromptModal';

export default ImpersonaPromptModal;
